import { render, staticRenderFns } from "./model-reference-mapping.vue?vue&type=template&id=51a1abca&scoped=true"
import script from "./model-reference-mapping.vue?vue&type=script&lang=js"
export * from "./model-reference-mapping.vue?vue&type=script&lang=js"
import style0 from "./model-reference-mapping.vue?vue&type=style&index=0&id=51a1abca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1abca",
  null
  
)

export default component.exports